import { Grid } from '@mui/material';

import { TextField, StatesSingleAutocomplete } from '@occc-app/design-system';

import { RetailerNetworkLocationGroupSingleSelectField } from '../../components/retailer-network-location-group-single-select-field.component';

type GeneralDetailsFormFieldsProps = {
  retailerNetworkUuid: string;
};

export const GeneralDetailsFormFields = ({
  retailerNetworkUuid,
}: GeneralDetailsFormFieldsProps) => (
  <>
    <Grid container spacing={3}>
      <Grid item xs={12} md={4}>
        <TextField required label='Location Name' name='details.name' type='text' margin='normal' />
      </Grid>

      <Grid item xs={12} md={4}>
        <RetailerNetworkLocationGroupSingleSelectField
          name='details.locationGroup'
          label='Location Group'
          retailerNetworkUuid={retailerNetworkUuid}
          inputProps={{ margin: 'normal' }}
        />
      </Grid>
    </Grid>

    <Grid container spacing={3}>
      <Grid item xs={12} md={4}>
        <TextField required label='Street 1' name='details.street1' type='text' margin='normal' />
      </Grid>

      <Grid item xs={12} md={4}>
        <TextField label='Street 2' name='details.street2' type='text' margin='normal' />
      </Grid>

      <Grid item xs={12} md={4}>
        <TextField required label='City' name='details.city' type='text' margin='normal' />
      </Grid>
    </Grid>

    <Grid container spacing={3}>
      <Grid item xs={12} md={4}>
        <StatesSingleAutocomplete
          name='details.state'
          label='State'
          inputProps={{ required: true, margin: 'normal' }}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <TextField required label='Zip Code' name='details.zipCode' type='text' margin='normal' />
      </Grid>

      <Grid item xs={12} md={4}>
        <TextField label='Phone Number' name='details.phoneNumber' type='tel' margin='normal' />
      </Grid>
    </Grid>
  </>
);
